import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";
import {Objects} from "components";
import {Link} from "react-router-dom";


export default class DealerDuplicates extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Dealers._name);
		super(props, model);
		this.request = 'GET_DUPLICATE'

	}
	handleToggleModalReview = async (e) => {
		this.setState({
			duplicateId: e.currentTarget.id,
			duplicateBinaryId: e.currentTarget.getAttribute('binary_id'),
			modalReview: true
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Company Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/dealers/" + props.original.binary_id + '-' + props.value}>{props.original.name_company}</Link>
			},
			{
				Header: "Display Name",
				id: "name_display",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.name_display)
			},
			{
				Header: "FFL",
				id: "ffl",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.ffl)
			},
			{
				Header: "Phone",
				id: "number_main",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.number_main)
			},
			{
				Header: "Address",
				id: "street_1",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.street_1)
			},
			{
				Header: "City",
				id: "city",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.city)
			},
			{
				Header: "State",
				id: "state",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.state)
			},
			{
				Header: "Zip Code",
				id: "zip",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.zip)
			},
			{
				Header: "FFL Expiration",
				id: "ffl_expiration",
				/** @param {Dealers_Object} obj */
				accessor: obj => {

					return obj.ffl_expiration ? moment(obj.ffl_expiration)
						.local()
						.format("MM/DD/YYYY") : ""
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				Cell: props => {
					return (
						<span>

							<Button
								id={props.original.pkey}
								binary_id={props.original.binary_id}
								onClick={this.handleToggleModalReview}
								color="green-meadow"
								size="sm"
								block={true}
							>
								<i className={"fa fa-balance-scale"}/> Review
							</Button>
						</span>

					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Dealer Logs', "")}
							{this.renderHeaderRight("Dealer Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<UniversalModalOverride
						id={this.state.duplicateId}
						binary_id={this.state.duplicateBinaryId}
						parent={this.props.parent}
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						name={"Review"}
						url={'dealers'}
						title={"Compare Dealers"}
						object={Objects.DealerCompare}
						toggle={this.state.modalReview}
						reportClose={this.reportClose('modalReview')}
						submitLabel={"Merge Dealers"}
						size={"lg"}
						hideGoTo={true}
						afterSave={this.props.reloadPage}
						objectProps={{
							handleTabChange: this.props.handleTabChange
						}}
					/>
				</CardContent>
			</Card>
		)
	}
}
